<template>
  <server-error v-if="error"/>
  <sticky-cta-page v-else :cta-props="ctaProps" @click="next">
    <header-page :header-props="headerProps">
      <dashboard-page :image-header-props="imageHeaderProps">
        <template v-slot:header>
          <div class="header">
            <img src="/images/im-on-it-100-days/on-it-100-days-logo-purple-flower.svg" class="im-on-it">
            <div class="title-text ri-small-display">
              <span>הצטרפת</span>
              <span>בהצלחה!</span>
            </div>
          </div>
        </template>
        <template v-slot:dashboard>
          <card>
            <bullet text="הצטרפות לתוכנית 'על זה ב־100'" :checked="true"/>
          </card>
        </template>
        <template v-slot:default>
          <div class="unchecked-bullets padding-left-ml padding-right-ml padding-top-sm">
            <card>
              <bullet text="חידוש המינוי לרייזאפ" :checked="false"/>
            </card>
            <card>
              <bullet text="יצאנו לדרך עם הקבוצה" :checked="false"/>
            </card>
          </div>
        </template>
      </dashboard-page>
    </header-page>
  </sticky-cta-page>
 </template>
<script>

import { mapState } from 'vuex';
import router from '@/router';
import DDLogs from '@/DDLogs';

import isDormantWinback from '@/utils/dormant-winback';
import ServerError from '@/pages/general-errors/ServerError.vue';
import CustomersApi from '@/api/CustomersApi';
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';
import Bullet from './Bullet.vue';

export default {
  async created() {
    Segment.trackUserGot('DormantWinback100DaysOnItWelcomePageEntered');
    const shouldShowDormantWinback = await isDormantWinback();
    if (!shouldShowDormantWinback) {
      // Will be called if the customer clicks "back"
      Segment.trackUserInteraction('DormantWinback100DaysOnItWelcomePageEnteredByMistake');
      await router.push({ path: '/sr' });
    }
  },
  data() {
    return {
      error: false,
      isLoading: false,
      headerProps: {
        showLogo: true,
        bottomBorder: true,
        rightActions: this.actions,
        backgroundColor: BaseUI.Colors.riseupGreen,
        textColor: BaseUI.LayoutConsts.COLOR_VARIANT.WHITE,
        logoColor: BaseUI.LayoutConsts.COLOR_VARIANT.WHITE,
      },
      imageHeaderProps: {
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
        title: '',
        bottomSeparator: false,
        imgSrc: '/images/shapes/cropped-flower.svg',
        backgroundPosition: BaseUI.LayoutConsts.BACKGROUND_POSITION.BOTTOM_LEFT,
      },
      ctaProps: {
        buttonProps: {
          loading: this.isLoading,
          title: 'המשך לחידוש המינוי',
        },
      },

    };
  },
  components: {
    Bullet,
    Card: BaseUI.Card,
    ServerError,
    HeaderPage: BaseUI.Pages.HeaderPage,
    StickyCtaPage: BaseUI.Pages.StickyCtaPage,
    DashboardPage: BaseUI.Pages.DashboardPage,
  },
  name: 'ResetCashflow',
  computed: {
    ...mapState('websocket', ['socketMessage']),
  },
  methods: {
    async next() {
      Segment.trackUserInteraction('DormantWinback100DaysOnItWelcomePageClickedNext');
      try {
        DDLogs.log('Resetting cashflow from reset-cashflow page');
        this.isLoading = true;
        await CustomersApi.resetForDormant();
        DDLogs.log('Waiting for version in reset-cashflow page');
      } catch (error) {
        DDLogs.error('Failed resetting cashflow for dormant', { error });
        this.error = true;
      }
    },
  },
  watch: {
    socketMessage(newValue, oldValue) {
      if (this.isLoading && newValue !== oldValue) {
        DDLogs.log('Done waiting for version in cashflow reset page, moving to next page');
        this.$router.push({ path: '/subscription' });
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings.scss';

.card {
  box-shadow: none !important;
  height: 80px !important;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  align-self: flex-start;
  margin-top: $ri-spacing-l;
  gap: $ri-spacing-sm;

  .title-text {
    display: flex;
    flex-direction: column;
  }

  .im-on-it {
    width: 97px;
    height: 64px;
  }
}

.unchecked-bullets {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  align-self: flex-start;
  gap: $ri-spacing-sm;
}

</style>
